/* global $ */
'use strict;'

import HCBaseTheme from '../hcbasetheme.es6.js';

class HCAreaSpline extends HCBaseTheme {
  constructor(container) {
    super();

    this.container = container;

    this.options = {
      chart: {
        type: 'areaspline'
      },
      plotOptions: {
        areaspline: {
          color: {
            linearGradient: { x1: 0, x2: 1, y1: 0, y2: 0 },
            stops: [
              [0, '#D6F1FD'],
              [1, '#64C9F5']
            ]
          },
          marker: {
            enabled: false,
            states: {
              hover: {
                enabled: false
              }
            }
          },
          states: {
            hover: {
              lineWidthPlus: 0
            }
          }
        }
      },
      yAxis: {
        labels: {
          format: '{value}'
        }
      }
    };

    this.paths = [];
    this._drawAreaColumns = this._drawAreaColumns.bind(this);

    this._resizeEventHandler();
  }

  drawChart() {
    super.drawChart(this.container, this.options, this._drawAreaColumns);
    return this;
  }

  _resizeEventHandler() {
    let resizeTimer;

    $(window).on('resize', (e) => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this._drawAreaColumns($(this.container).highcharts());
      }, 150);
    });
  }

  _drawAreaColumns(chart) {
    (this.paths).forEach((path, index) => {
      path.element.remove();
    });

    (chart.series[0].data).forEach((point, index) => {
      const pos = chart.plotBox.x + point.plotX;

      let path = chart.renderer.path(['M', pos, 0, 'V', chart.chartHeight])
      .attr({
        'stroke-width': 1,
        stroke: 'white',
        zIndex: 4
      })
      .add();

      this.paths.push(path);
    });
  }
}

export default HCAreaSpline;
